const backendAPI = {
  address: "http://demo.vogic.ai:80",
};

export default backendAPI;
